import { useRef } from 'react';
import { DragStoppedEvent, DragStartedEvent } from 'ag-grid-community';
import { compareTwoArrayOfObjects, createOrUpdateKeyState } from '../ultils';
import LZString from 'lz-string';

const useDragColumnChange = (
  keyState: string,
  currentUrl: string,
  updateUrl: (suffixUrl: string) => void,
  setIsOrderByColumn: (stat: boolean) => void,
  isLoggedIn?: boolean
) => {
  const columnOrderRef = useRef<any>({});
  let onDragStarted = (e: DragStartedEvent) => {
    columnOrderRef.current = e.columnApi.getColumnState().map((c: any) => {
      return { colId: c.colId };
    });
  };

  let onDragStopped = (e: DragStoppedEvent) => {
    const colStates = e.columnApi.getColumnState().map((c: any) => {
      return { colId: c.colId };
    });

    const isSameState = compareTwoArrayOfObjects(
      columnOrderRef.current,
      colStates
    );

    // ! Check if there are any changes then save at local storage
    if (!isSameState) {
      createOrUpdateKeyState(keyState, 'colStates', colStates);
      let urlParamsColumnStages = new URLSearchParams(
        new URL('', currentUrl).search
      );
      const decodedParams = new URLSearchParams(
        '?' +
          LZString.decompressFromEncodedURIComponent(
            urlParamsColumnStages.get('s')!
          )
      );
      setIsOrderByColumn(true);

      decodedParams.set('colStages', JSON.stringify(colStates));
      decodedParams.set('isOrderByColumn', 'true');

      updateUrl(
        `${LZString.compressToEncodedURIComponent(decodedParams.toString())}`
      );
    }
  };

  if (!isLoggedIn) {
    onDragStarted = () => {};
    onDragStopped = () => {};
  }
  return { onDragStarted, onDragStopped };
};

export default useDragColumnChange;
